import $ from "jquery";
import Swiper from "swiper";
import { Navigation, Pagination, Scrollbar, Autoplay, Thumbs, EffectCoverflow, EffectFade } from "swiper/modules";
Swiper.use([Navigation, Pagination, Scrollbar, Autoplay, Thumbs, EffectCoverflow, EffectFade]);
window.Swiper = Swiper;

import "swiper/css/bundle";

const initializeSliders = function (sliders) {
    // Helper to parse options from data attribute
    const parseOptions = (el) => el ? JSON.parse(el.dataset.sliderOptions || "{}") : {};

    // Helper to assign unique navigation button classes and update options
    const assignNavButtons = (sliderId, options, type = "main") => {
        ["prev", "next"].forEach((btn) => {
            const selector = type === "main"
                ? `#${sliderId} .swiper-button-${btn}.main-button, #${sliderId} .swiper-button-${btn}`
                : `#${sliderId} .swiper-button-${btn}.thumbnail-button`;
            const button = document.querySelector(selector);
            if (button) {
                const btnClass = `${sliderId}-${type}-${btn}`;
                button.classList.add(btnClass);
                options.navigation = options.navigation || {};
                options.navigation[`${btn}El`] = `.${btnClass}`;
            }
        });
    };

    // Helper to handle reduced motion settings
    const applyReducedMotion = (options, reduced) => {
        if (reduced) {
            options.autoplay = false;
            options.speed = 0;
        }
    };

    // Helper to (re)initialize Swiper instances
    const reinitSlider = (selector, options, onSlideChange) => {
        const instance = new Swiper(selector, options);
        if (onSlideChange) instance.on("slideChange", onSlideChange);
        return instance;
    };

    const mediaQuery = window.matchMedia("(prefers-reduced-motion: reduce)");

    if (sliders.thumb != null) {
        let mainOptions = parseOptions(sliders.main);
        let thumbOptions = parseOptions(sliders.thumb);

        assignNavButtons(sliders.id, mainOptions, "main");
        assignNavButtons(sliders.id, thumbOptions, "thumb");

        const originalMainOptions = JSON.parse(JSON.stringify(mainOptions));
        const originalThumbOptions = JSON.parse(JSON.stringify(thumbOptions));

        applyReducedMotion(mainOptions, !mediaQuery || mediaQuery.matches);
        applyReducedMotion(thumbOptions, !mediaQuery || mediaQuery.matches);

        let thumbSlider = reinitSlider(`#${sliders.id} .thumbnail-carousel`, thumbOptions);
        mainOptions.thumbs = { swiper: thumbSlider };
        let mainSlider = reinitSlider(`#${sliders.id} .carousel`, mainOptions, slideChange);

        function slideChange() {
            const currentSlide = mainSlider.slides[mainSlider.activeIndex];
            if (currentSlide.classList.contains("youtube")) {
                const iframe = currentSlide.querySelector("iframe");
                // Uncomment to play video: 
                // if (iframe) iframe.contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', '*');
            } else {
                mainSlider.slides.forEach((slide) => {
                    const iframe = slide.querySelector("iframe");
                    if (iframe) {
                        iframe.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', "*");
                    }
                });
            }
        }

        mediaQuery.addEventListener("change", () => {
            mainSlider?.destroy();
            thumbSlider?.destroy();

            mainOptions = JSON.parse(JSON.stringify(originalMainOptions));
            thumbOptions = JSON.parse(JSON.stringify(originalThumbOptions));
            applyReducedMotion(mainOptions, mediaQuery.matches);
            applyReducedMotion(thumbOptions, mediaQuery.matches);

            thumbSlider = reinitSlider(`#${sliders.id} .thumbnail-carousel`, thumbOptions);
            mainOptions.thumbs = { swiper: thumbSlider };
            mainSlider = reinitSlider(`#${sliders.id} .carousel`, mainOptions, slideChange);
        });
    } else {
        let mainOptions = parseOptions(sliders.main);
        assignNavButtons(sliders.id, mainOptions, "main");

        const originalMainOptions = JSON.parse(JSON.stringify(mainOptions));
        applyReducedMotion(mainOptions, !mediaQuery || mediaQuery.matches);

        const swiperSelector = sliders?.selector ? `#${sliders.id} .${sliders.selector}` : `#${sliders.id} .carousel`;
        let mainSlider = reinitSlider(swiperSelector, mainOptions);

        mediaQuery.addEventListener("change", () => {
            mainSlider?.destroy();
            mainOptions = JSON.parse(JSON.stringify(originalMainOptions));
            applyReducedMotion(mainOptions, mediaQuery.matches);
            mainSlider = reinitSlider(swiperSelector, mainOptions);
        });

        if (typeof cardSliders !== "undefined") {
            cardSliders = cardSliders.map(({ container, id }) => {
                if (id === sliders.id) {
                    return { id, container, instance: mainSlider };
                }
                return { id, container };
            });
        }
    }
};
window.initializeSliders = initializeSliders;

// Apply above function to all sliders.
function msInitializeDynamicSliders() {
    let listOfSliders = [];
    const allContentCarouselSliders = document.querySelectorAll(".ms_content-carousel");
    for (const sliders of allContentCarouselSliders) {
        listOfSliders.push({
            id: sliders.id,
            main: sliders.querySelector(".swiper"),
            thumb: null,
            selector: "swiper",
        });
    }

    const allCarouselSliders = document.querySelectorAll(".ms_carousel");
    for (const sliders of allCarouselSliders) {
        listOfSliders.push({
            id: sliders.id,
            main: sliders.querySelector(".carousel"),
            thumb: sliders.querySelector(".thumbnail-carousel"),
            selector: "carousel",
        });
    }

    const allCardSliders = document.querySelectorAll(".ms_cards");
    for (const sliders of allCardSliders) {
        if (sliders.querySelector(".card-slider")) {
            listOfSliders.push({
                id: sliders.id,
                main: sliders.querySelector(".card-slider"),
                thumb: null,
                selector: "card-slider",
            });
        }
        if (sliders.querySelector(".card-mobile-slider")) {
            listOfSliders.push({
                id: sliders.id,
                main: sliders.querySelector(".card-mobile-slider"),
                thumb: null,
                selector: "card-mobile-slider",
            });
        }
    }

    const allProductSliders = document.querySelectorAll(".ms_products");
    for (const sliders of allProductSliders) {
        if (sliders.querySelector(".product-slider")) {
            listOfSliders.push({
                id: sliders.id,
                main: sliders.querySelector(".product-slider"),
                thumb: null,
                selector: "product-slider",
            });
        }
        if (sliders.querySelector(".product-mobile-slider")) {
            listOfSliders.push({
                id: sliders.id,
                main: sliders.querySelector(".product-mobile-slider"),
                thumb: null,
                selector: "product-mobile-slider",
            });
        }
    }

    const allTestimonialSliders = document.querySelectorAll(".ms_testimonial-quote");
    for (const sliders of allTestimonialSliders) {
        if (sliders.querySelector(".item-slider")) {
            listOfSliders.push({
                id: sliders.id,
                main: sliders.querySelector(".item-slider"),
                thumb: null,
                selector: "item-slider",
            });
        }
    }

    const allUSPSSliders = document.querySelectorAll(".ms_usps");
    for (const sliders of allUSPSSliders) {
        if (sliders.querySelector(".usps-slider")) {
            listOfSliders.push({
                id: sliders.id,
                main: sliders.querySelector(".usps-slider"),
                thumb: null,
                selector: "usps-slider",
            });
        }
    }

    if (listOfSliders.length !== 0) {
        for (const sliders of listOfSliders) {
            initializeSliders(sliders);
        }
    }
}

document.addEventListener(
    `DOMContentLoaded`,
    function () {
        msInitializeDynamicSliders();
    },
    { passive: true },
);

if (typeof acf !== "undefined") {
    acf.addAction(`render_block_preview`, function ($el, attributes) {
        msInitializeDynamicSliders();
    });
}

$(".swiper-button-next, .swiper-button-prev").on("mousedown", function (e) {
    e.preventDefault();
});
